export const DBNPARTNER_SUBSCRIPTIONS_RESET_STATE = 'DBNPARTNER_SUBSCRIPTIONS_RESET_STATE';
export const DBNPARTNER_SUBSCRIPTIONS_CURRENT_ITEM = 'DBNPARTNER_SUBSCRIPTIONS_CURRENT_ITEM';

export const DBNPARTNER_SUBSCRIPTIONS_REQUEST_LOADING = 'DBNPARTNER_SUBSCRIPTIONS_REQUEST_LOADING';
export const DBNPARTNER_SUBSCRIPTIONS_REQUEST_SUCCESS = 'DBNPARTNER_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const DBNPARTNER_SUBSCRIPTIONS_REQUEST_FAILED = 'DBNPARTNER_SUBSCRIPTIONS_REQUEST_FAILED';

export const DBNPARTNER_SUBSCRIPTIONS_CURRENT_ACTION = 'DBNPARTNER_SUBSCRIPTIONS_CURRENT_ACTION';
export const DBNPARTNER_SUBSCRIPTIONS_RESET_ACTION = 'DBNPARTNER_SUBSCRIPTIONS_RESET_ACTION';
